<script setup lang="ts">
import { tv } from "tailwind-variants";

const packet = inject(keys.currentPacket);

const variants = tv({
  variants: {
    theme: {
      "green-seagreen": "bg-yellow-20 text-green-50",
      "green-red": "bg-blue-20 text-green-50",
      "blue-pink": "bg-orange-20 text-blue-50",
      "dark-red-pink": "bg-coral-20 text-red-40",
    },
  },
});

const classes = computed(() => variants({ theme: unref(packet)?.theme }));
</script>

<template>
  <UiStripesArticles
    v-if="packet?.relatedArticles?.length"
    :show-all="true"
    :title="`Les om ${packet.title || packet.name}`"
    :articles="packet.relatedArticles"
    :class="classes"
  />
</template>
